export default {
  "content": "<path d=\"M18.5 10h-13V8h13v2z\" fill=\"#7B61FF\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M19.5 4a3 3 0 013 3v10a3 3 0 01-3 3h-15a3 3 0 01-3-3V7a3 3 0 013-3h15zm-15 2a1 1 0 00-1 1v10a1 1 0 001 1h15a1 1 0 001-1V7a1 1 0 00-1-1h-15z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};